import React from 'react';
import {INavState} from 'features/layout/redux/helpers/FoldersHelper';

export interface TreeExpandCollapseContext {
   flattened: INavState[];
   expanded: string[];
   setExpanded: (nodeIds: string[]) => void;
   toggleNode: (nodeId: string) => void;
}

export const treeExpandCollapseContextDefaultValue = {
   flattened: [] as INavState[],
   expanded: [],
   setExpanded: () => {
      console.error('setExpanded is not provided');
   },
   toggleNode: () => {
      console.error('toggleNode is not provided');
   },
};
export const treeExpandCollapseContext = React.createContext<TreeExpandCollapseContext>(
   treeExpandCollapseContextDefaultValue
);
